import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Asset, AssetType } from '@shared/models';
import { YoutubeService } from '@shared/services/youtube.service';
@Component({
  selector: 'youtube-selector',
  templateUrl: './youtube-selector.component.html',
  styleUrls: ['./youtube-selector.component.scss', '../file-manager.component.scss']
})
export class YoutubeSelectorComponent implements OnInit{
  @Input() type: AssetType;
  @Output() selected = new EventEmitter<Asset>();
  currentVideo: any;
  isLoading = false;
  constructor(
    private _youtubeService: YoutubeService
    ) {}
  ngOnInit(): void {}
  onPaste(event: ClipboardEvent): void{
    const clipboardData = event.clipboardData || (window as any).clipboardData;
    const pastedText = clipboardData.getData('text');
    this.youtubeSearch(pastedText);
  }
  youtubeSearch(link: string): void{
    this.isLoading = true;
    this._youtubeService.findYoutubeVideo(link).subscribe(videoData => {
      this.isLoading = false;
      if (videoData.published){
        const date = new Date(videoData.published);
        videoData.readableDatePublished = date.toLocaleDateString();
        videoData.type = this.type;
        videoData.readableLength = videoData.length_seconds % 60 + ' min';
      }
      
      this.currentVideo = videoData;
    });
  }
  selectVideo(): void{
    this.isLoading = true;
    this._youtubeService.createYoutubeMedia(this.currentVideo)
    .subscribe(media => {
      this.isLoading = false;
      this.selected.emit(media);
    });
  }
}
